<template>
    <div>
        <van-nav-bar :title="title" placeholder fixed>
            <template #left>
                <van-icon @click="goback" name="arrow-left" size="22" color="#000" />
            </template>
        </van-nav-bar>
        <div class="tim_cont_c " @scroll="scrollEventSay">
            <div v-for="(item, index) in wordList" :key="item.id">
                <div class="tim_time" v-show="index == 0">
                    {{ item.createtime | dateFormat }}
                </div>
                <div v-if="index != 0" class="tim_time">
                    <span v-if="item.createtime - wordList[index - 1].createtime > 5 * 60">
                        {{ item.createtime | dateFormat }}
                    </span>
                </div>

                <div v-if="item.type == 'system'" class="tim_system">
                    <i class="el-icon-warning"></i>
                    <span>
                        {{ item.message }}
                    </span>
                </div>
                
                <div v-if="item.type != 'system'">
                    <div class="left_cont_i" v-if="item.sender_id == userinofid">
                        <img class="avatar" :src="item.user_info.avatar" alt="" srcset="">
                        <div v-if="item.type == 'default'" class="xx" style="margin-left: 10px;">
                            {{ item.message }}
                        </div>
                        <div v-if="item.type == 'file'" class="file xx" style="margin-left: 10px;">
                            <div class="file_flex">
                                <div class="imgs">
                                    <img src="../../assets/tim/fs.png" alt="">
                                </div>
                                <div>
                                    <div class="filename">{{ item.filename }}</div>
                                    <div class="filesize"> {{ item.filesize}} </div>
                                </div>
                                <div class="imgsd" @click="download(item)">
                                    <img src="../../assets/tim/down.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div v-if="item.type == 'image'" style="margin-left: 10px;">
                            <el-image :preview-src-list="[item.message]"
                                style="width: 100px;height: 100px;border-radius: 6px;" :src="item.message"></el-image>
                        </div>
                        <div v-if="item.type == 'link_text'"  v-html="item.message" class="xx" style="margin-left: 10px;">

                        </div>
                    </div>

                    <div class="right_cont_i" v-if="item.sender_id != userinofid">
                        <div class="rig">
                            <img class="avatar" :src="item.user_info.avatar" alt="" srcset="">
                            <div v-if="item.type == 'default'" class="xx" style="margin-right: 10px;">
                                {{ item.message }}
                            </div>
                            <div v-if="item.type == 'file'" class="file xx" style="margin-right: 10px;">
                                <div class="file_flex">
                                    <div class="imgs">
                                        <img src="../../assets/tim/fs.png" alt="">
                                    </div>
                                    <div>
                                        <div class="filename">{{ item.filename | urlCode }}</div>
                                        <div class="filesize"> {{ item.filesize }} </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="item.type == 'image'" class="img" style="margin-right: 10px;">
                                <el-image :preview-src-list="[item.message]"
                                    style="width: 100px;height: 100px;border-radius: 6px;" :src="item.message"></el-image>
                            </div>
                            <div v-if="item.type == 'link_text'"  v-html="item.message" class="xx" style="margin-right: 10px;">

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { messageList } from '@/api/txim'
export default {
    name: '',
    data() {
        return {
            title: '',
            params: {
                page: 1,
                limit: 15,
                ztim_session_id: ''
            },
            wordList: [],
            userinofid: ''
        }
    },
    mounted() {
        console.log(this.$route.query);
        this.userinofid = this.$route.query.user_info.id
        this.params.ztim_session_id = this.$route.query.id
        this.title = this.$route.query.user_info.nickname + '聊天记录'
        console.log(this.$route.query.id);
        messageList(this.params).then(res => {
            if (res.code == 1) {
                this.wordList = res.data.list
                if (this.wordList.length != 0) {
                    this.scrollEvent()
                }
            }
        })
    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        // 控制滚动条滚动到底部
        scrollEvent() {
            // 自动滚动到底部
            this.$nextTick(() => {
                let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                msg.scrollTop = msg.scrollHeight + 10
            });
        },
        // 监听滚动条的高度，滚动到顶部后拉取聊天数据
        scrollEventSay(e) {
            this.scrollHeight = e.srcElement.scrollHeight;
            if (e.srcElement.scrollTop == 0) {
                this.params.page++
                messageList(this.params).then(res => {
                    this.wordList.unshift(...res.data.list)
                    this.$nextTick(() => {
                        let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                        msg.scrollTop = msg.scrollHeight - this.scrollHeight; // 滚动高度
                    });
                })
            }
        },
    },
}
</script>
<style lang='scss' scoped>
.tim_cont_c {
    height: calc(100vh - 46px);
    overflow-y: auto;
    background: #F7F8FA;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(144, 147, 153, 0.3);
        cursor: pointer;
        border-radius: 4px;
    }

    .icons {
        border: 1px solid red;
        margin-top: 100px;
    }

    .tim_time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #ADAAAA;
        text-align: center;
    }

    .tim_system {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 13px;
        color: #f05151;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }


    .left_cont_i {
        margin: 16px;
        display: flex;
    }

    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 6px;
    }

    .right_cont_i {
        margin: 16px;
        text-align: right;
    }

    .isread {
        font-size: 12px;
        position: absolute;
        bottom: 0%;
        left: -30px;
        color: #ADAAAA !important;
    }

    .cobule {
        color: rgb(78, 78, 255) !important;
    }

    .rig {
        display: flex;
        flex-direction: row-reverse;
        position: relative;
    }

    .xx {
        max-width: 70%;
        background-color: #fff;
        border-radius: 4px;
        align-items: center;
        text-align: left;
        padding: 10px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        position: relative;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: normal;
    }

    .img {
        max-width: 70%;
        border-radius: 4px;
        align-items: center;
        text-align: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        position: relative;
    }

    .file {
        max-width: 70%;
        padding: 10px;
        background-color: #fff;
        border-radius: 4px;
        align-items: center;
        text-align: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        position: relative;

        .file_flex {
            display: flex;
            align-items: center;
        }

        .imgs {
            width: 40px;
            height: 40px;
            background: #E5FCFF;
            border-radius: 5px 5px 5px 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;

            img {
                width: 28px;
                height: 28px;
            }
        }

        .imgsd {
            width: 34px;
            height: 34px;
            margin-left: 20px;
            cursor: pointer;
        }

        .filename {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
        }

        .filesize {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #ADAAAA;
        }
    }

    .xx::before {
        content: '';
        position: absolute;
        left: -5px;
        width: 8px;
        height: 8px;
        transform: rotate(45deg);
        background-color: #fff;
    }

    .rig>.xx::before {
        left: unset;
        right: -5px;
    }
}
</style>